import React from 'react';
interface Props {
  fillColor?: string;
}
function HomeNursingIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none">
      <g clipPath="url(#clip0_851_3485)">
        <path
          d="M3 2.44219V4.24844H3.00938C3.00313 4.32969 3 4.41406 3 4.49844V5.24844V5.59219C3 6.65156 2.57812 7.67031 1.82812 8.42031L1.70625 8.54219C1.575 8.67344 1.5 8.85469 1.5 9.04219C1.5 9.43281 1.81562 9.74844 2.20625 9.74844H7H11.7937C12.1844 9.74844 12.5 9.43281 12.5 9.04219C12.5 8.85469 12.425 8.67344 12.2937 8.54219L12.1719 8.42031C11.4219 7.67031 11 6.65156 11 5.59219V5.24844V4.49844C11 4.41406 10.9969 4.32969 10.9906 4.24844H11V2.44219C11 2.02656 10.7406 1.65156 10.35 1.50469L7.35 0.379688C7.125 0.295313 6.875 0.295313 6.64687 0.379688L3.64687 1.50469C3.25937 1.65156 3 2.02344 3 2.44219ZM9.5 5.24844V5.74844C9.5 7.12969 8.38125 8.24844 7 8.24844C5.61875 8.24844 4.5 7.12969 4.5 5.74844H5.5C6.43125 5.74844 7.24688 5.23906 7.675 4.48281C8.04063 4.94844 8.60938 5.24844 9.25 5.24844H9.5ZM1.5625 14.6828C1.80625 13.4734 2.75 12.5172 3.95 12.2547L5.58437 13.8891C6.36562 14.6703 7.63125 14.6703 8.4125 13.8891L10.0469 12.2547C11.25 12.5172 12.1906 13.4734 12.4344 14.6828H1.5625ZM4.075 10.7141C1.77812 10.9859 0 12.9359 0 15.3047C0 15.7922 0.39375 16.1859 0.88125 16.1859H13.1219C13.6094 16.1859 14.0031 15.7922 14.0031 15.3047C14 12.9359 12.2219 10.9859 9.925 10.7172C9.65312 10.6859 9.3875 10.7953 9.19375 10.9891L7.35313 12.8297C7.15938 13.0234 6.84062 13.0234 6.64687 12.8297L4.80625 10.9891C4.6125 10.7953 4.34687 10.6828 4.075 10.7172V10.7141ZM6.5 1.74844C6.5 1.61094 6.6125 1.49844 6.75 1.49844H7.25C7.3875 1.49844 7.5 1.61094 7.5 1.74844V2.24844H8C8.1375 2.24844 8.25 2.36094 8.25 2.49844V2.99844C8.25 3.13594 8.1375 3.24844 8 3.24844H7.5V3.74844C7.5 3.88594 7.3875 3.99844 7.25 3.99844H6.75C6.6125 3.99844 6.5 3.88594 6.5 3.74844V3.24844H6C5.8625 3.24844 5.75 3.13594 5.75 2.99844V2.49844C5.75 2.36094 5.8625 2.24844 6 2.24844H6.5V1.74844Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3485">
          <rect
            width="14"
            height="16"
            fill="white"
            transform="translate(0 0.25)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default HomeNursingIcon;
